// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"VY-z","subtitle":"WY-z","wrapper":"XY-z","leftArrow":"YY-z","rightArrow":"ZY-z"};